/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Injectable } from '@angular/core';
import { UserInfoService } from '../services/user-info.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Grant, PermissionConfigCriterion } from '@xt/core/permissions';
import { USER_ROLE } from '../store/reducers/session-info.reducer';

@Injectable({
  providedIn: 'root',
})
export class RequireUserRole implements PermissionConfigCriterion {
  private userInfoService = inject(UserInfoService);

  grants(value): Observable<boolean> {
    return this.userInfoService.userTypeInfo$.pipe(
      map((typeInfo) => typeInfo.roles.includes(value)),
    );
  }

  //unverified role
  static readonly PRIVATE_RECORD = Grant.require(
    RequireUserRole,
    USER_ROLE.PRIVATE_RECORD,
  );

  //verified roles
  static readonly CUR_VERIFIED_PATIENT = Grant.require(
    RequireUserRole,
    USER_ROLE.PATIENT,
  );

  static readonly CUR_VERIFIED_PROVIDER = Grant.require(
    RequireUserRole,
    USER_ROLE.HCP,
  );

  static readonly CUR_VERIFIED_REPRESENTATIVE = Grant.require(
    RequireUserRole,
    USER_ROLE.VERIFIED_REPRESENTATIVE,
  );

  //verifier roles
  static readonly CUR_PROVIDER_VERIFIER = Grant.require(
    RequireUserRole,
    USER_ROLE.PROVIDER_VERIFIER,
  );

  static readonly CUR_REPRESENTATIVE_VERIFIER = Grant.require(
    RequireUserRole,
    USER_ROLE.REPRESENTATIVE_VERIFIER,
  );

  //additional roles
  static readonly DPO = Grant.require(RequireUserRole, USER_ROLE.DPO);
}
